import type { TrackItem } from "../types"

export function timeToSeconds(time: string) {
  const [minutes, seconds] = time
    .split(":")
    .map(Number)

  return (minutes || 0) * 60 + (seconds || 0)
}

export function sumTrackTimes(
  tracks: TrackItem[] = []
) {
  const totalSeconds = tracks.reduce(
    (total, track) => {
      return (
        total +
        timeToSeconds(track.trackTime || "0:00")
      )
    },
    0
  )

  const totalMinutes = Math.round(
    totalSeconds / 60
  )

  return `${totalMinutes}m`
}